import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder } from '@angular/forms';
import { StoresService } from '../../../../core/routing/services/stores_api/stores.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { GlobalConstants } from '../../../constants/global.constant';
import { Stores } from '../../../../modules/users/stores/interface/store.i';
import { ActiveUserConstants } from '../../../../core/routing/services/activeusers_api/constatnts/activeusers.constant';
import { CommonService } from '../../../../common/services/common.service';
import {
  StoresConstant
} from '../../../../core/routing/services/stores_api/constants/stores.constant';

@Component({
  selector: 'iposcen-send-to-segment-account',
  templateUrl: './send-to-segment-account.component.html',
  styleUrls: ['./send-to-segment-account.component.scss']
})
export class SendToSegmentAccountComponent implements OnInit {
  @ViewChild('searchValue') animateThis: ElementRef;
  @Input() sendName: string;
  @Input() sendButtonName: string;
  @Input() sendToStoreSuccess: boolean;
  @Output() readonly clearAllData = new EventEmitter<any>();
  @Output() readonly selectedStoreData = new EventEmitter<any>();
  retailUserId = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
  //IIT2-1476
  countryList = [];
  stateProvinceList = [];
  storesData = [];
  filterString: string;
  closeFilter: boolean;
  stateFilterName = ActiveUserConstants.STATE_FILTER;
  countryFilterName = ActiveUserConstants.COUNTRY_FILTER;
  noRecordFound = GlobalConstants.NO_RECORDS_FOUND;
  stateDropdownSelectedValue: string;
  countriesDropdownSelectedValue: string;
  eachSendToStore = {
    storeName: '',
    storeId: ''
  };
  stateVal: string;
  countryVal: string;
  totalSelectedCount: number;
  isMasterSel: boolean;
  searchClose: boolean;
  selectedStores = [];
  displayStoresData = [];
  page: number;
  pageSize: number;
  isStateSelected: boolean;
  isCountrySelected: boolean;
  isAllSelected: boolean;
  loggedInUser: boolean;
  stateDefault: string;
  countryDefault: string;
  searchData: string;
  searchTag: string;
  storeNameHeading = GlobalConstants.STORE_NAME;
  cancelButtonText = GlobalConstants.CANCEL;
  storeNumberHeading = GlobalConstants.STORE_NUMBER;
  storeIDHeading = GlobalConstants.STORE_ID;
  stateHeading = GlobalConstants.STORE_STATE;
  countryHeading = GlobalConstants.STORE_COUNTRY;
  direction: string;
  globalSortValue: string;
  globalSortBy: string;
  searchQueue = {};
  sortQueue = {};
  loadFlag: string;
  paginationCount: number;
  totalPages: number;
  maxSize = 5;
  filters = { searchData: null, countryData: null, stateData: null }
  isSelected = new Map();
  sendData = new Map();
  isSearched: boolean = false;
  searchPlaceholderText: string = $localize`:@@send-to-segment-account.search-input.placeholder:Search stores…`;
  isStoreDataEmpty: boolean;
  loadingText = GlobalConstants.LOADING;
  isLoading = false;

  @ViewChild('sendToAccountModal') private modalContent: TemplateRef<SendToSegmentAccountComponent>;
  private modalRef: NgbModalRef;
  private modalOption: NgbModalOptions = {};
  private ngUnsubscribe = new Subject();

  constructor(private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private storesService: StoresService,
    private cmnService: CommonService) { }

  ngOnInit(): void {
    this.direction = this.cmnService.direction;
    this.page = 1;
    this.filterString = '';
    this.closeFilter = false;
    this.pageSize = 10;
    this.loadFlag = StoresConstant.LOAD_FLAG;
    this.getIntialValue();
    this.stateVal = GlobalConstants.STATE_NAME;
    this.countryVal = GlobalConstants.COUNTRY_NAME;
    this.stateDefault = GlobalConstants.STATE_NAME;
    this.countryDefault = GlobalConstants.COUNTRY_NAME;
    this.loggedInUser = true;
    this.globalSortBy = StoresConstant.CREATED_TIME;
    this.globalSortValue = StoresConstant.DESCENDING_ORDER;
  }

  getIntialValue() {
    this.isStateSelected = false;
    this.isCountrySelected = false;
    this.isAllSelected = false;
    this.searchData = '';
    this.totalSelectedCount = 0;
  }

  getAllStoresByUserID(filterString?: string) {
        this.storesService
      .getAllStoresbyUserID(this.globalSortBy, this.globalSortValue, this.page, filterString, this.retailUserId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllStoresResponse => {
        this.totalPages = getAllStoresResponse.paginationContext.totalItems;
        this.paginationCount = (getAllStoresResponse.paginationContext.totalItems);
        this.storesData = getAllStoresResponse.store as Stores[];
        this.isStoreDataEmpty = !this.storesData.length;
        this.displayStoresData = this.storesData;
        this.countryList = getAllStoresResponse.locationList;
        this.stateProvinceList = getAllStoresResponse.stateProvinceList;
        this.storesData.forEach(ele => {
          ele.checked = false;
        });
        this.isMasterSel = false;
        this.stateProvinceList = [...new Set(getAllStoresResponse.stateProvinceList
          .map(stateProvinceList => stateProvinceList))];
        this.stateProvinceList.sort();
        this.countryList = [...new Set(getAllStoresResponse.locationList.map(countries => countries))];
        this.countryList.sort();
      });
  }
  filterData(type, data) {
    if (type == StoresConstant.STORE_NAME_SEARCH) {
      this.isSearched = true;
      this.filters.searchData = data;
    } else if (type === ActiveUserConstants.COUNTRY_FILTER) {
      this.filters.countryData = data;
    } else if (type === ActiveUserConstants.STATE_FILTER) {
      this.filters.stateData = data;
    }
    this.filterDataSend();
  }
  filterDataSend() {
    this.filterString = '';
    this.page = 1;
    if (this.filters.searchData) {
      this.filterString += `&${StoresConstant.STORE_NAME_SEARCH}=${this.filters.searchData}`;
    }
    if (this.filters.countryData) {
      this.filterString += `&${ActiveUserConstants.COUNTRY_FILTER}=${this.filters.countryData}`;
    }
    if (this.filters.stateData) {
      this.filterString += `&${ActiveUserConstants.STATE_FILTER}=${this.filters.stateData}`;
    }
    this.isSelected.clear();
    this.sendData.clear();
    this.getAllStoresByUserID(this.filterString)
  }
  clearFilters(type) {
    this.page = 1;
    if (type == StoresConstant.STORE_NAME_SEARCH && this.searchData.length === 0 && this.isSearched) {
      this.filters.searchData = null;
      this.isSearched = false;
      this.searchData = '';
      this.filterDataSend();
    } else if (type === ActiveUserConstants.COUNTRY_FILTER) {
      this.filters.countryData = null;
      this.filterDataSend();
    } else if (type === ActiveUserConstants.STATE_FILTER) {
      this.filters.stateData = null;
      this.filterDataSend();
    }
  }
  selectedData(data) {
    if (this.isSelected.has(data.storeId)) {
      this.isSelected.delete(data.storeId);
    } else {
      this.isSelected.set(data.storeId, true);
      this.sendData.set({ 'storeId': data.storeId, 'storeName': data.storeName }, true)
    }
  }
  isStoreSelectAll() {
    if (this.isSelected.size !== this.totalPages) {
      this.storesService.getAllStores(this.globalSortBy, this.globalSortValue, this.filterString, this.retailUserId)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(getAllStoresResponse => {
            this.totalPages = getAllStoresResponse.paginationContext.totalItems;
            this.paginationCount = (getAllStoresResponse.paginationContext.totalItems);
            getAllStoresResponse.store.forEach(data => {
              this.isSelected.set(data.storeId, true)
              this.sendData.set({ 'storeId': data.storeId, 'storeName': data.storeName }, true)
            });
          });

    } else {
      this.isSelected.clear();
    }
  }
  onAdd() {
    this.selectedStoreData.emit({ sentToStores: Array.from(this.sendData.keys()) });
  }
  open() {
    this.getAllStoresByUserID();
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalRef = this.modalService.open(this.modalContent, this.modalOption);
    this.modalRef.result.then();
      }

  close() {
    this.getIntialValue();
    this.selectedStores = [];
    this.pageInitValue();
    this.modalRef.close();
  }
  pageInitValue(){
    this.page = 1;
    this.filterString = '';
    this.isSelected.clear();
    this.sendData.clear();
    this.getAllStoresByUserID();
  }
  dismiss() {
    this.pageInitValue();
    this.stateVal = GlobalConstants.STATE_NAME;
    this.countryVal = GlobalConstants.COUNTRY_NAME;
    this.filters = { searchData: null, countryData: null, stateData: null }
    this.getIntialValue();
    this.selectedStores = [];
    this.sendToStoreSuccess = false;
    this.clearAllData.emit(false);
    this.modalRef.dismiss();
  }
  onTableDataChange(event) {
    this.page = event;
    this.getAllStoresByUserID(this.filterString);
  }
  onTypeSearch(value) {
    if (value !== StoresConstant.EMPTY_VALUE) {
      this.searchClose = true;
    }
  }
}
//IIT2-1476 end
